export { getLogoSrc } from './utils/logo'
export * from './hooks/useUpdateCustomer'
export { toCustomerUpdateBody } from './utils/toCustomerUpdateBody'
export { CustomerSelect } from './components/CustomerSelect'
export { CustomerMultiSelect } from './components/CustomerMultiSelect'
export { CustomerSelectPill } from './components/CustomerSelectPill'
export { CustomerAliasSelect } from './components/CustomerAliasSelect'
export type { Customer } from './types'
export { useFetchCustomerQuery } from './hooks/useFetchCustomerQuery'
export { useLoadDistinctCustomerAliasCount } from './useLoadDistinctCustomerAliasCount'
export { CustomerLogo } from './components/CustomerMeta/CustomerLogo'
export { CustomerLogoById } from './components/CustomerLogoById'
export { CustomerPreviewCard } from './components/CustomerPreviewCard'
export {
  customerIdFilterConfig,
  aliasesByCustomerFilterConfig
} from './customerMagicTableFilter'
export {
  CustomerFormFields,
  useCustomerFormFields,
  CustomerAliasField
} from './components/CustomerFormFields'
export { LinkToCustomerMenuItem } from './components/menuItems/LinkToCustomerMenuItem'
export { LinkToNewCustomerMenuItem } from './components/menuItems/LinkToNewCustomerMenuItem'
export { LinkAliasToCustomerModal } from './components/modals/LinkAliasToCustomer/LinkAliasToCustomer.modal'
export { useUnmappedAliasResolution } from './hooks/useUnmappedAliasResolution'
export type {
  CustomerFormFieldsData,
  CustomerFormSectionValidation,
  UseCustomerFormFieldsProps,
  CustomerFormErrors,
  Contact as CustomerFormContact
} from './components/CustomerFormFields'
